import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useVersion } from '../hooks/useVersion';
import CoveringScreen from './CoveringScreen';

interface Props {
  message?: string | React.ReactNode;
  progressBar?: boolean;
  action?: React.ReactNode;
}

const CoveringLoadingScreen: FC<Props> = ({ message, progressBar, action }) => {
  const { version } = useVersion();
  return (
    <CoveringScreen
      message={
        message || (
          <FormattedMessage defaultMessage="Söker efter konfiguration..." />
        )
      }
      progressBar={progressBar}
      action={action}
      version={version}
    />
  );
};

export default CoveringLoadingScreen;
